import React from "react";
import styled from 'styled-components'
import { Col, Row } from 'react-bootstrap';
import Image from 'react-bootstrap/Image'

const NotAvailable = () => {

    const notAvailableImage = 'https://storage.googleapis.com/tdglobal-dev/public%2Fgowaterfall_1585209563_xs6ff4UZPLfVrhiUMmxCjG.png'

    return (
        <Container>
            <Row>
                <Col xs={12}>
                    <NotAvailableImage style={{backgroundImage:`url(${notAvailableImage})`}}/>
                </Col>
                <Col xs={12}>
                    <div style={{width: '75%', float: 'none', color: '#316797', fontSize: '13px', textAlign: 'center', margin: '0 auto'}}>Sorry these features are currently offline until the COVID-19 pandemic has subsided.</div>
                </Col>
            </Row>
            
        </Container>
    );
}

const Container = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
    float:left;
    background: #fff;
    @media only screen and (max-width: 2400px) {
        width: 66%;
        height: 100%;
        position: relative;
        float:none;
        margin: 0 auto;
    };
    @media only screen and (max-width: 800px) {
        width: 95% !important;
        height: 100%;
        position: relative;
        float:none;
        margin: 0 auto;
        background: #fff;
    };
`

const NotAvailableImage = styled.div`
    height: 25rem;
    width: 15rem;
    background-repeat: no-repeat;
    background-size: contain;
    display: flex;
    justify-content: center;
    margin: 0 auto;
`

export default NotAvailable;